import { StyleConfig } from "@chakra-ui/react";

export const Icon: StyleConfig = {
  baseStyle: {
    width: 4,
    height: 4,
  },
};
